/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';

export function StaticSelect(props) {
  const { app, data, em } = props;
  // const { parentSize } = em;
  const parentSize = em.parentSize || (props.parent && props.parent.size) || 'half';
  const floating = em.floating;
  const groupClass = (floating ? '' : 'row') + ' ' + (em.class ? em.class : '');
  const labelClass = floating ? 'label' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  const inputClass = floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`;

  const handleDefaultChange = useCallback((e) => {}, []);

  return (
    <div className={`form-group ${groupClass}`}>
      <label className={`${labelClass}`}>{em.label}</label>
      <select
        className={`form-control ${inputClass}`}
        name={(em && em.field) || em.name}
        title={em.label || em.field}
        value={data && em.field && (data[em.field] || '')}
        onChange={props.onChange || handleDefaultChange}
      >
        <option value="">---</option>
        {em.options &&
          em.options.map((t, i) => {
            return (
              <option key={i} value={t.value}>
                {t.text}
              </option>
            );
          })}
      </select>
    </div>
  );
}

StaticSelect.defaultProps = {
  em: {}, // { parentSize: 'half' },
};

export function ValidSelect(props) {
  const { app, data, em } = props;
  // const { parentSize } = em;
  const parentSize = em.parentSize || (props.parent && props.parent.size) || 'half';
  const floating = em.floating;
  const groupClass = (floating ? '' : 'row mr-1') + ' ' + (em.class ? em.class : '');
  const labelClass = floating ? 'label' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  const inputClass = floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`;

  // const handleDefaultChange = useCallback((e) => {});

  return (
    <div className={`form-group ${groupClass}`}>
      <label className={`${labelClass}`}>{em.label}</label>
      <select
        className={`form-control ${inputClass}`}
        name={(em && em.field) || em.name}
        title={em.label || em.field}
        value={data && em.field && (data[em.field] || '')}
        onChange={props.onChange}
      >
        <option value="">---</option>
        {em.options &&
          app[em.options] &&
          app[em.options].map((t, i) => {
            return (
              <option key={i} value={t.type_code}>
                {t.type_desc}
              </option>
            );
          })}
      </select>
    </div>
  );
}

ValidSelect.defaultProps = {
  em: {}, // parentSize: 'half'
  app: {},
};
